export default {
  state: {
    academyAutoresponder: {},
    academyData: {},
    academyGlobalConfiguration: {},
    academyShowHeaderMessage: true,
    academyLegals: {},
    academyLoadingSubmenu: true,
    academyResources: {},
    academyDaysLeft: null
  },

  getters: {
    getAcademyAutoresponder (state) {
      return state.academyAutoresponder
    },

    getAcademyData (state) {
      return state.academyData
    },

    getAcademyGlobalConfiguration (state) {
      return state.academyGlobalConfiguration
    },

    getAcademyShowHeaderMessage (state) {
      return state.academyShowHeaderMessage
    },

    getAcademyLegals (state) {
      return state.academyLegals
    },

    getAcademyLoadingSubmenu (state) {
      return state.academyLoadingSubmenu
    },

    getAcademyResources (state) {
      return state.academyResources
    },

    getAcademyDaysLeft (state) {
      return state.academyDaysLeft
    }
  },

  mutations: {
    setAcademyAutoresponder (state, academyAutoresponder) {
      state.academyAutoresponder = academyAutoresponder
    },

    setAcademyData (state, academyData) {
      state.academyData = academyData
    },

    setAcademyGlobalConfiguration (state, academyGlobalConfiguration) {
      state.academyGlobalConfiguration = academyGlobalConfiguration
    },

    setAcademyShowHeaderMessage (state, academyShowHeaderMessage) {
      state.academyShowHeaderMessage = academyShowHeaderMessage
    },

    setAcademyLegals (state, academyLegals) {
      state.academyLegals = academyLegals
    },

    setAcademyLoadingSubmenu (state, academyLoadingSubmenu) {
      state.academyLoadingSubmenu = academyLoadingSubmenu
    },

    setAcademyResources (state, academyResources) {
      state.academyResources = academyResources
    },

    setAcademyDaysLeft (state, academyDaysLeft) {
      state.academyDaysLeft = academyDaysLeft
    },

    unsetAcademyAutoresponder (state) {
      state.academyAutoresponder = {}
    },

    unsetAcademyData (state) {
      state.academyData = {}
    },

    unsetAcademyGlobalConfiguration (state) {
      state.academyGlobalConfiguration = {}
    },

    unsetAcademyShowHeaderMessage (state) {
      state.academyShowHeaderMessage = true
    },

    unsetAcademyLegals (state) {
      state.academyLegals = {}
    },

    unsetAcademyLoadingSubmenu (state) {
      state.academyLoadingSubmenu = true
    },

    unsetAcademyResources (state) {
      state.academyResources = {}
    },

    unsetAcademyDaysLeft (state) {
      state.academyDaysLeft = null
    }
  }
}
